// ─── Meeting Code Formatting ─────────────────────────────────────────────────

export const normalizeCode = (value: string) =>
  value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase()

export const formatCode = (value: string) => {
  const v = normalizeCode(value).slice(0, 10)
  const a = v.slice(0, 3)
  const b = v.slice(3, 7)
  const c = v.slice(7, 10)
  return [a, b, c].filter(Boolean).join("-")
}

export const generateCode = () => {
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789"
  const pick = (n: number) =>
    Array.from({ length: n }, () => chars[Math.floor(Math.random() * chars.length)]).join("")
  return `${pick(3)}-${pick(4)}-${pick(3)}`
}

// ─── Time / Date ─────────────────────────────────────────────────────────────

export const formatTime = (date = new Date()) =>
  date.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true })

export const formatTimestamp = (ts: number) => {
  const d = new Date(ts)
  const now = new Date()
  const sameDay =
    d.getDate() === now.getDate() &&
    d.getMonth() === now.getMonth() &&
    d.getFullYear() === now.getFullYear()
  if (sameDay) return formatTime(d)
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric" })
}

// ─── File Size ────────────────────────────────────────────────────────────────

export const formatFileSize = (bytes: number) => {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}

// ─── Initials ─────────────────────────────────────────────────────────────────

export const getInitials = (name: string) =>
  name
    .split(" ")
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? "")
    .join("")
